import styles from "./styles/faq-item.module.scss";
import { useState } from "react";
import arrowUp from "@/assets/sidebar/arrow-up.svg";
import arrowDown from "@/assets/sidebar/arrow-down.svg";
import Image from "next/image";
import { FaqItemData } from "@/data/faq.data";
import React from "react";
import Link from "next/link";

interface FaqItemProps {
  data: FaqItemData;
}

const FaqItem = ({ data }: FaqItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.faq_item_wrapper}>
      <div
        className={styles.faq_item}
        onClick={() => setIsOpen(!isOpen)}
        style={{ borderColor: isOpen ? "#F9A825" : "#434343" }}
      >
        <div className={styles.faq_question}>{data.question}</div>
        <Image
          src={isOpen ? arrowUp : arrowDown}
          alt={isOpen ? "Close" : "Open"}
        />
      </div>
      {isOpen && (
        <div className={styles.faq_answer}>
          {data.answer.split("\n").map((line, idx) => (
            <div key={idx}>
              {line}
              <br />
            </div>
          ))}
          {data.linkHref ? (
            <Link className={styles.faq_link} href={data.linkHref}>
              {data.linkText}
            </Link>
          ) : (
            <div className={styles.faq_link}>{data.linkText}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default FaqItem;
